var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoomerangElement01 = function SvgBoomerangElement01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "boomerang_element-01_svg2__a",
    cx: 237.2,
    cy: 183.29,
    r: 190.85,
    fx: 237.2,
    fy: 183.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M105.83 73.43c4 5.78 7.91 11.43 11.5 16.64 6.01-5.61 10.8-11.24 16.68-15.3 11.14-7.68 26.37-5.93 36.33 3.19 11.69 10.72 13.13 29.64 1.71 42.23-6.91 7.63-17.48 11.08-27.64 9.41-10.79-1.77-17.83-8.74-23.71-16.85-7.2-9.92-13.1-20.8-20.53-30.52-6.25-8.18-12.97-16.53-21.1-22.63-15.29-11.46-32.71-12.83-50.13-4.69C11.49 63.06 1.83 77.33.19 96.43c-1.94 22.51 11.29 43.11 32.04 50.48 21.28 7.55 41.14 1.77 56.51-14.03 1.94-2 3.69-4.19 5.26-6.49s-11.47-16.56-11.47-16.56c-5.81 5.36-10.87 11.29-17.09 15.49-12.79 8.63-29.71 5.36-39.1-6.64-9.23-11.8-8.29-28.54 2.22-39.36 12.59-12.97 32.58-12.73 45.21 1.84 8.38 9.67 14.64 21.16 22.36 31.45 6.58 8.77 13.01 17.98 21.09 25.23 16.79 15.09 41.26 16.29 59.67 4.38 18.42-11.91 27.27-34.26 21.24-55.56-5.61-19.82-18.96-32.14-39.21-35.73-22.07-3.92-39.22 5.13-53.09 22.49Z",
    style: {
      fill: "url(#boomerang_element-01_svg2__a)",
      strokeWidth: 0
    }
  }));
};
export default SvgBoomerangElement01;